"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrainingApiServiceInstance = void 0;
const client_1 = require("@rws-framework/client");
let TrainingApiService = class TrainingApiService extends client_1.RWSService {
    constructor(apiService) {
        super();
        this.apiService = apiService;
    }
    prepareTrainingDataForBackend(data, includeSystemPrompt = true) {
        // Convert training data to JSONL format for fine-tuning
        const jsonlLines = data.map(item => {
            const messages = [];
            // Add system prompt if requested
            if (includeSystemPrompt) {
                messages.push({
                    role: "system",
                    content: "You are a helpful assistant trained to provide accurate and helpful responses."
                });
            }
            // Add user message (input)
            messages.push({
                role: "user",
                content: item.input
            });
            // Add assistant response (output)
            messages.push({
                role: "assistant",
                content: item.output
            });
            return JSON.stringify({ messages });
        });
        return jsonlLines.join('\n');
    }
    async startTraining(config, data) {
        try {
            // Prepare data in JSONL format
            const jsonlData = this.prepareTrainingDataForBackend(data, true);
            // Upload training data
            const filename = `training_data_${config.modelName}_${Date.now()}.jsonl`;
            const payloadBody = {
                config,
                data
            };
            const response = (await this.apiService.back.post('trainer.start', payloadBody));
            if (!response.success) {
                throw new Error(`Training start failed: ${response.error}`);
            }
            return response.job.id;
        }
        catch (error) {
            console.error('Error starting training:', error);
            throw error;
        }
    }
    async getTrainingStatus(trainingId) {
        try {
            // Use apiService.back for backend call
            const response = await this.apiService.back.get('trainer.progress', { routeParams: { modelId: trainingId } });
            // Transform backend response to our TrainingProgress format
            return {
                stage: response.stage,
                progress: response.progress || 0,
                message: response.message,
                currentEpoch: response.currentEpoch,
                totalEpochs: response.totalEpochs,
                loss: response.loss,
                accuracy: response.accuracy,
                estimatedTimeRemaining: response.estimatedTimeRemaining
            };
        }
        catch (error) {
            console.error('Error getting training status:', error);
            // Return error state
            return {
                stage: 'error',
                progress: 0,
                message: `Error checking status: ${error.message}`
            };
        }
    }
    async cancelTraining(trainingId) {
        try {
            // Use apiService.back for backend call
            await this.apiService.back.post('trainer.cancel', { modelId: trainingId });
        }
        catch (error) {
            console.error('Error canceling training:', error);
            throw error;
        }
    }
    async handleJobDone(jobId, modelId, results, status, error) {
        try {
            const request = {
                jobId,
                modelId,
                results,
                status,
                error
            };
            const response = await this.apiService.back.post('trainer.jobDone', request);
            return response;
        }
        catch (error) {
            console.error('Error handling job completion:', error);
            throw error;
        }
    }
};
exports.TrainingApiServiceInstance = TrainingApiService;
exports.TrainingApiServiceInstance = TrainingApiService = __decorate([
    __param(0, client_1.ApiService),
    __metadata("design:paramtypes", [typeof (_a = typeof client_1.ApiServiceInstance !== "undefined" && client_1.ApiServiceInstance) === "function" ? _a : Object])
], TrainingApiService);
exports.default = TrainingApiService.getSingleton();
